import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import PaymentMethods from "ui/organizms/PaymentMethods";

const PaymentMethodsScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Payment Methods'
    >
        <PaymentMethods />
    </Screen>
);

export default memo(PaymentMethodsScreen);
